<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		:modal-scroll="false"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="`master/invoice-voucher/apply`"
			>
				<!-- Voucher -->
				<div class="form-group row align-items-center">
					<label for="input_voucher_id" class="col-sm-3 mb-0">
						Voucher
					</label>
					<app-input
						id="input_voucher_id"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_voucher_id"
						@input="setVoucherIdValue"
						:fetch-url="`${API_VOUCHER_BY_LEAD}?clc_id_number=${clc_id_number}&academic_calendar_id=${academic_calendar_id}`"
						placeholder="Voucher"
						list-value-field="voucher_category"
						:required="true"
					/>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin.js";
import { API_VOUCHER_BY_LEAD } from "../../../../../../../Config/ApiUrl.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin.js";

export default {
	name: "FeesNoticeDetailsDeductionsTableFormVoucher",
	inject: ["eventHub"],
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		invoiceRequestId: {
			type: Number,
			required: true,
		},
		value: {
			type: Object,
			default: () => {
				return {
					voucher_category_id: undefined,
					code: "",
					name: "",
					is_active: "",
					voucher_category: {
						id: undefined,
						code: "",
						name: "",
						is_active: "",
					},
					center_id: {
						id: undefined,
						name: "",
						is_active: "",
					},
				};
			},
		},
	},
	data() {
		return {
			API_VOUCHER_BY_LEAD: API_VOUCHER_BY_LEAD,
			preloader: false,
			clc_id_number: null,
			academic_calendar_id: null,
			inputs: {
				invoice_id: this.invoiceRequestId,
				voucher_id: 0,
				// qty: 1,
				// price: "",
				// amount: "",
				// is_deduction: true,
			},
			input_voucher_id: this.value
				? this.value.voucher
					? {
							id: this.value.voucher.id || 0,
							name: this.value.voucher.name || "",
							code: this.value.voucher.code,
							is_active: this.value.voucher.is_active,
					  }
					: {
							id: this.value.voucher?.id || 0,
							name: this.value.voucher?.name || "",
							code: this.value.voucher?.code,
							is_active: this.value.voucher?.is_active,
					  }
				: {
						id: this.value.voucher.id || 0,
						name: this.value.voucher.name || "",
						code: this.value.voucher.code,
						is_active: this.value.voucher.is_active,
				  },
			modalId: this.formId,
			modalTitle: this.$t("add"),
			voucherIdLists: [],
			formattedPrice: "",
		};
	},
	created() {
		if (!this.clc_id_number || !this.academic_calendar_id) this.fetchData();
	},
	methods: {
		async fetchData() {
			try {
				this.preloader = true;
				if (this.selectedUrl) {
					this.modalTitle = this.$t("edit");
				}

				const res = await axios.get(`/transaction/invoice-v2/${this.invoiceRequestId}`);
				this.clc_id_number = res.data.clc_id_number;
				this.academic_calendar_id = res.data.academic_calendar_id;
				this.preloader = false;
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},
		submit() {
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
			this.eventHub.$emit("studentFeesNoticeDetailsDeductionChanged");
		},

		afterSuccessFromGetEditData(response) {
			this.inputs = response.data;
			this.preloader = false;
		},
		setVoucherIdValue(data) {
			console.log('setVoucherIdValue.inputs:', this.inputs);
			console.log('setVoucherIdValue.data:', data);
			this.inputs.voucher_id = this.inputs.voucher_id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.voucher_id = data.id;
				this.inputs.price = data.price;
			}
		},
	},
	computed: {
		calculatedAmount() {
			return this.inputs.qty * this.inputs.price;
		},
		formattedAmount() {
			return new Intl.NumberFormat("id-ID", {
				style: "currency",
				currency: "IDR",
				minimumFractionDigits: 0,
			}).format(this.inputs.amount);
		},
		formattedPriceDisplay() {
			return new Intl.NumberFormat("id-ID", {
				style: "currency",
				currency: "IDR",
				minimumFractionDigits: 0,
			}).format(this.inputs.price);
		},
	},
	watch: {
		calculatedAmount(newAmount) {
			this.inputs.amount = newAmount;
		},
		"inputs.price": function (newVal) {
			// Update formattedPrice whenever inputs.price changes
			this.formattedPrice = new Intl.NumberFormat("id-ID", {
				style: "currency",
				currency: "IDR",
				minimumFractionDigits: 0,
			}).format(newVal);
		},
	},
};
</script>
